import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      modelRules: [
        v => Rules.isRequired(v),
      ],
      resourceTypeRules: [
        v => Rules.isRequired(v),
      ],
      subjectIdRules: [
        v => Rules.isRequired(v),
      ],
      expiryDateRules: [
        v => Rules.isRequired(v),
      ]
    }
  }
}

